module.exports = __webpack_public_path__ + "img/淘宝.397b9a70.svg";